<custom-dropdown-list-container class="custom-dropdown-container" [matTooltip]="tooltip" [matTooltipPosition]="'above'" [(isDropdownOpen)]="isMenuOpen">
    <div class="custom-dropdown-select" dropdown-toggle>
        <div>
            {{menuTitle}}
        </div>
        <div class="custom-arrow-wrapper">
            <i class="custom-arrow" [class.down]="!isMenuOpen" [class.up]="isMenuOpen"></i>
        </div>
    </div>
    <div class="custom-dropdown-items custom-dropdown-light" dropdown-list>
        <ng-content></ng-content>
    </div>
</custom-dropdown-list-container>